import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';

import { IDigitalAddress } from '../../../../types/contact';
import { notifySuccess } from '../../../../services/notification';
import { CancelIcon, SaveIcon } from '../../../common/icons';
import { GET_POSITION_EMAILS, UPDATE_POSITION_EMAIL } from '../../../../graphql/contact-gql';
import EmailDetails, { EmailHandler } from './email-detail';
import Button from '../../../common/button';

type DigitalAddressUpdateProps = {
    digitalAddress?: IDigitalAddress;
    isRole: boolean;
    isOpen: boolean;
    toggle: () => void;
}

const EmailUpdate = (props: DigitalAddressUpdateProps) => {
    const {digitalAddress, isRole, isOpen, toggle} = props
    const [updateDigitalAddress] = useMutation(UPDATE_POSITION_EMAIL)

    const [validated, setValidated] = useState<boolean>(true)
    const digitalAddressRef = useRef<EmailHandler>(null)

    const saveDigitalAddress = () => {
        if (digitalAddressRef.current && !digitalAddressRef.current.validate(true)) {
            setValidated(false)
            return
        }
        let emailInput = digitalAddressRef.current && digitalAddressRef.current.getEmail()
        updateDigitalAddress({
            variables: {
                positionId: digitalAddress?.businessEntityId,
                input: emailInput
            },
            refetchQueries: [{
                query: GET_POSITION_EMAILS,
                variables: { positionId: digitalAddress?.businessEntityId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onChange = () => {
        setValidated(!!digitalAddressRef.current?.validate(false))
    }

    return (
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle}  tag={'h2'}>Update a {isRole ? 'Role' : 'Position'} Email Address</ModalHeader>
            <ModalBody>
                <EmailDetails ref={digitalAddressRef} digitalAddress={digitalAddress} isRole={isRole} onChange={onChange} autoFocus={true}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={saveDigitalAddress}  disabled={!validated}><SaveIcon/> Update</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
  )
}

export default EmailUpdate
